import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { HTTPService } from "./http.service";
import { orElse } from "../model/operator/or-else.operator";
import { Campaign } from "../persistence/dto/campaign.model";
import { SmallCampaignDto } from "../core/models/smallCampaignDto.model";

/**
 * @description
 *  Servicio reflejo del controlador de campañas del backend.
 *
 * @see gigot-backend/Controllers/CampaignsController.cs
 */

@Injectable({ providedIn: "root" })
export class CampaignService implements Controller {

    constructor(private httpService: HTTPService) { }

    public basePath(): string {
        return "api/campaigns";
    }

    public allCampaigns(): Observable<Campaign[]> {
        return this.httpService.send<typeof undefined, Campaign[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath("")
                .build())
            .pipe(
                orElse<Campaign[]>([] as Campaign[]),
                map(campaigns => campaigns.map(campaign => Campaign.from(campaign))));
    }

    public getInvoincingCampaign(): Observable<Campaign[]> {
        return this.httpService.send<typeof undefined, Campaign[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`/getInvoincingCampaign`)
                .build())
            .pipe(
                orElse<Campaign[]>([] as Campaign[]),
                map(campaigns => campaigns.map(campaign => Campaign.from(campaign))));
    }
    
    /**
     * @description
     *  Obtiene la campaña actual y las proximas por venir.	 
     */
    public getActualAndNextCampaignsByZone(zone: number): Observable<SmallCampaignDto[]> {
        return this.httpService.send<typeof undefined, SmallCampaignDto[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`${zone}/active-next`)
                .build())
            .pipe(
                orElse<SmallCampaignDto[]>([] as SmallCampaignDto[])
            )
    }

    public campaignByID(id: number): Observable<Campaign> {
        return this.httpService.send<typeof undefined, Campaign>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`${id}`)
                .build())
            .pipe(
                map(campaign => Campaign.from(campaign)));
    }

    public campaignsByYear(year: number): Observable<Campaign[]> {
        return this.httpService.send<typeof undefined, Campaign[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`year/${year}`)
                .build())
            .pipe(
                orElse<Campaign[]>([] as Campaign[]),
                map(campaigns => campaigns.map(campaign => Campaign.from(campaign))));
    }
}
